import React, { Component } from 'react';

class GoogleMap extends Component {
    render() {
        return (
          <div className="contact-bottom">
            <div className="contac-bottom">
              <div className="row justify-content-center g-0">
                <div className="col-12">
                  <div className="location-map">
                    <div id="map">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d214592.19513311386!2d-96.89724918697652!3d32.81868418680583!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c19f77b45974b%3A0xb9ec9ba4f647678f!2sDallas%2C%20TX%2C%20USA!5e0!3m2!1sen!2sin!4v1739426510194!5m2!1sen!2sin"
                        width="600"
                        height="450"
                        style={{ border: "0" }}
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
    }
}

export default GoogleMap;